<script setup>
import {ref, watch} from "vue";

const emit = defineEmits(['input']);

const editMode = ref(false);
const model = ref('');

watch(editMode, (value) => {
    if (!value && model.value.length) {
        emit('input', model.value);
    }
});
</script>

<template>
    <input
        v-if="editMode"
        v-model="model"
        class="form-input"
        v-click-outside="() => editMode = false"
        @keyup.enter="editMode = false"
    >

    <a v-else @click.stop="editMode = true" class="error status-rejected">
        <b>Add URL</b>
    </a>
</template>

<style scoped>

</style>
